module.exports = __webpack_public_path__ + "img/more.f32d1fd2.png";